import { render, staticRenderFns } from "./visitor-managment.vue?vue&type=template&id=77870db4&scoped=true&"
import script from "./visitor-managment.vue?vue&type=script&lang=js&"
export * from "./visitor-managment.vue?vue&type=script&lang=js&"
import style0 from "./visitor-managment.vue?vue&type=style&index=0&id=77870db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77870db4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VRow,VSimpleTable,VSpacer,VTextField})
